import { writable } from 'svelte/store';

export type WmsUpdateSafety = { registered: boolean; busy: boolean; routes: readonly string[] };
type GuardKind = 'receiving' | 'home' | 'supporting';

export function createWmsUpdateSafety() {
  const guards = new Map<symbol, { busy: boolean; kind: GuardKind }>();
  const state = writable<WmsUpdateSafety>({ registered: false, busy: true, routes: [] });
  function publish() {
    const routes = [...guards.values()].flatMap((guard) => guard.kind === 'receiving'
      ? ['/wms/mottak'] : guard.kind === 'home' ? ['/wms'] : []);
    state.set({
      registered: routes.length > 0,
      routes,
      busy: [...guards.values()].some((guard) => guard.busy)
    });
  }
  return {
    subscribe: state.subscribe,
    register(kind: GuardKind = 'receiving') {
      const owner = Symbol();
      guards.set(owner, { busy: true, kind });
      publish();
      return {
        setBusy(busy: boolean) {
          if (!guards.has(owner)) return;
          guards.set(owner, { busy, kind });
          publish();
        },
        dispose() {
          guards.delete(owner);
          publish();
        }
      };
    }
  };
}

export const wmsUpdateSafety = createWmsUpdateSafety();

export function canReloadWmsPage(pathname: string, state: WmsUpdateSafety): boolean {
  return state.routes.includes(pathname.replace(/\/$/, '')) && state.registered && !state.busy;
}
